import type { NaturezaAcaoOption } from '../pages/relatorio-civel-page.models';

export function normalizeTipoRecursoLabel(label: string): string {
  return label
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .replace(/\s+/g, ' ')
    .toUpperCase();
}

/** Tipos de recurso exibidos na etapa Recursos (comparação case-insensitive). */
const TIPOS_RECURSO_PERMITIDOS = new Set(
  [
    'RECURSO',
    'RECURSO DE MEDIDA CAUTELAR',
    'RECURSO ESPECIAL',
    'RECURSO EXTRAORDINÁRIO',
    'RECURSO INOMINADO',
    'RECURSO ORDINÁRIO',
  ].map((label) => normalizeTipoRecursoLabel(label)),
);

export function filtrarOpcoesTipoRecurso(options: NaturezaAcaoOption[]): NaturezaAcaoOption[] {
  return options.filter((option) => {
    if (!option.value) return true;
    if (option.nucleo !== false) return false;
    return TIPOS_RECURSO_PERMITIDOS.has(normalizeTipoRecursoLabel(option.label));
  });
}
